import { Controller } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { Rating } from 'primereact/rating';

const BaseRating = (props) => {
    const {
        id,
        name,
        label,
        required = false,
        errors,
        className,
        placeholder,
        disabled = false,
        control,
        clearErrors,
        value,
        setValue
    } = props;

    return (
        <div className={twMerge('w-full', className)}>
            <div className='text-theme1-primary2 font-bold text-base mb-1'>{label}</div>
            {control && (
                <Controller
                    render={({ field }) => (
                        <Rating
                            cancel={false}
                            id={id ?? name}
                            name={name}
                            value={field.value}
                            onChange={(e) => {
                                field.onChange(e.value);
                                if (clearErrors) {
                                    clearErrors(name);
                                }
                            }}
                            placeholder={placeholder ?? label}
                            required={required}
                            disabled={disabled}
                            onIcon={
                                <svg
                                    width='44'
                                    height='43'
                                    viewBox='0 0 44 43'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                    className='mr-4'
                                >
                                    <path
                                        d='M21.6157 3.5835L27.152 14.7993L39.5324 16.6089L30.574 25.3343L32.6882 37.661L21.6157 31.8381L10.5432 37.661L12.6574 25.3343L3.69904 16.6089L16.0795 14.7993L21.6157 3.5835Z'
                                        fill='#FFB421'
                                        stroke='#FFB421'
                                        strokeWidth='3.58333'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </svg>
                            }
                            offIcon={
                                <svg
                                    width='44'
                                    height='43'
                                    viewBox='0 0 44 43'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                    className='mr-4'
                                >
                                    <path
                                        d='M21.6157 3.5835L27.152 14.7993L39.5324 16.6089L30.574 25.3343L32.6882 37.661L21.6157 31.8381L10.5432 37.661L12.6574 25.3343L3.69904 16.6089L16.0795 14.7993L21.6157 3.5835Z'
                                        fill='#D4C7C7'
                                        stroke='#D4C7C7'
                                        strokeWidth='3.58333'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </svg>
                            }
                        />
                    )}
                    control={control}
                    name={name}
                />
            )}

            {!control && (
                <Rating
                    cancel={false}
                    id={id ?? name}
                    name={name}
                    value={value}
                    onChange={(e) => {
                        if (setValue) {
                            setValue(e.value);
                        }
                    }}
                    placeholder={placeholder ?? label}
                    required={required}
                    disabled={disabled}
                    onIconProps={{ style: { marginRight: '32px' } }}
                    offIconProps={{ style: { marginRight: '32px' } }}
                    onIcon={
                        <svg
                            width='44'
                            height='43'
                            viewBox='0 0 44 43'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='mr-4'
                        >
                            <path
                                d='M21.6157 3.5835L27.152 14.7993L39.5324 16.6089L30.574 25.3343L32.6882 37.661L21.6157 31.8381L10.5432 37.661L12.6574 25.3343L3.69904 16.6089L16.0795 14.7993L21.6157 3.5835Z'
                                fill='#FFB421'
                                stroke='#FFB421'
                                strokeWidth='3.58333'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </svg>
                    }
                    offIcon={
                        <svg
                            width='44'
                            height='43'
                            viewBox='0 0 44 43'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='mr-4'
                        >
                            <path
                                d='M21.6157 3.5835L27.152 14.7993L39.5324 16.6089L30.574 25.3343L32.6882 37.661L21.6157 31.8381L10.5432 37.661L12.6574 25.3343L3.69904 16.6089L16.0795 14.7993L21.6157 3.5835Z'
                                fill='#D4C7C7'
                                stroke='#D4C7C7'
                                strokeWidth='3.58333'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </svg>
                    }
                />
            )}

            {errors &&
                errors.map((error) => {
                    return (
                        <div key={error} className='mt-2.5 text-theme1-error'>
                            {error}
                        </div>
                    );
                })}
        </div>
    );
};

export default BaseRating;
